
import sphere from '../../polyMesh/geometric/primitives/Sphere';

const Sphere = {
  schema: {
    radius: { label: 'Radius', type: 'Number', defaultValue: 0.5, minValue: 0.0, step: 0.1, animatable: true },
    widthSegments: { label: 'Longitudinal Segments', type: 'Integer', defaultValue: 24, minValue: 3, maxValue: 200, step: 1, animatable: true },
    heightSegments: { label: 'Latitudinal Segments', type: 'Integer', defaultValue: 24, minValue: 3, maxValue: 200, step: 1, animatable: true },
    phiStart: { label: 'Phi Start', type: 'Number', defaultValue: 0, minValue: 0, maxValue: 360, step: 10, animatable: true },
    phiLength: { label: 'Phi Length', type: 'Number', defaultValue: 360, minValue: 0, maxValue: 360, step: 10, animatable: true },
    thetaStart: { label: 'Theta Start', type: 'Number', defaultValue: 0, minValue: 0, maxValue: 180, step: 10, animatable: true },
    thetaLength: { label: 'Theta Length', type: 'Number', defaultValue: 180, minValue: 0, maxValue: 180, step: 10, animatable: true },
  },

  update: function (operator, primitive) {
    const { radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength } = operator;
    primitive.mesh = sphere(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
  },
};

export default Sphere;



// WEBPACK FOOTER //
// ./src/operators/PolyMesh/Sphere.js